/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List } from 'immutable'
import TransactionEvent from '../../event/TransactionEvent'
import { getIndexOfTransactionDetail, TransactionDetailStateOfAccommodationFee, TransactionDetailStateOfAccommodationTax, TransactionDetailStateOfOthers } from '../state/TransactionDetailState'

class TransactionDetailsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List([null, null, null])
  }

  reduce(state, action) {
    const payload = action.payload
    const { name, value, reservation } = payload
    let index = null
    let details = []

    switch (action.type) {
      case TransactionEvent.fetchReservation:
        // 初回ロード時
        return state.clear()

      case TransactionEvent.onEdit:
        const checkboxLabels = ['accommodation_fee_paid', 'accommodation_tax_paid', 'others_paid']
        if (checkboxLabels.includes(name)) {
          return value ? this.addColumn(reservation, state, name, payload.total_tax) : this.deleteColumn(state, name)
        }
        return state

      case TransactionEvent.onEditDetail:
        index = payload.index
        details = state.setIn([index, name], value)
        if (name === 'unit_price') {
          return List(details.setIn([index, 'total'], value))
        }
        return List(details)

      case TransactionEvent.onUpdateAccommodationTax:
        index = getIndexOfTransactionDetail('accommodation_tax_paid')
        details = state.setIn([index, 'unit_price'], value)
        return List(details)

      default:
        return state
    }
  }

  addColumn(reservation, details, type, totalTax) {
    let detail = null

    switch (type) {
      case 'accommodation_fee_paid':
        detail = TransactionDetailStateOfAccommodationFee(reservation)
        break
      case 'accommodation_tax_paid':
        detail = TransactionDetailStateOfAccommodationTax(reservation, totalTax)
        break
      default:
        detail = TransactionDetailStateOfOthers('', 0)
        break
    }

    const index = getIndexOfTransactionDetail(type)
    return details.set(index, detail)
  }

  deleteColumn(details, name) {
    const index = getIndexOfTransactionDetail(name)
    return details.set(index, null)
  }
}

export default new TransactionDetailsStore()
